module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.7b225d4d.woff";